import {
  NgxMatDateAdapter,
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule
} from '@angular-material-components/datetime-picker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AngularEditorModule, AngularEditorService } from '@kolkov/angular-editor';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { CustomDateAdapter, CustomNgxDateAdapter } from './classes/custom-date-adapter';
import { ActiveCallOverlayComponent } from './components/active-call-overlay/active-call-overlay.component';
import { AddAttachmentFieldComponent } from './components/add-attachment-field/add-attachment-field.component';
import { AddPictureFieldComponent } from './components/add-picture-field/add-picture-field.component';
import { AddPictureIconComponent } from './components/add-picture-field/add-picture-icon/add-picture-icon.component';
import { AppInvitationComponent } from './components/app-invitation/app-invitation.component';
import { ApxChartWrapperComponent } from './components/apx-chart-wrapper/apx-chart-wrapper.component';
import { AttachmentListInFormComponent } from './components/attachment-list-in-form/attachment-list-in-form.component';
import { AttachmentListInViewComponent } from './components/attachment-list-in-view/attachment-list-in-view.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { BrowserNtfToastComponent } from './components/browser-notification-toast/browser-ntf-toast.component';
import { ClickableRowTableComponent } from './components/clickable-row-table/clickable-row-table.component';
import { getPolishPaginatorIntl } from './components/clickable-row-table/paginator-intl';
import { CoOwnerIconComponent } from './components/co-owner-icon/co-owner-icon.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ContactBoxComponent } from './components/contact-box/contact-box.component';
import { ContactLinkComponent } from './components/contact-link/contact-link.component';
import { CropImageComponent } from './components/crop-image/crop-image.component';
import { DateConfirmationDialogComponent } from './components/date-confirmation-dialog/date-confirmation-dialog.component';
import { DetailsContactsComponent } from './components/details-contacts/details-contacts.component';
import { DetailsHeaderComponent } from './components/details-header/details-header.component';
import { DetailsSectionComponent } from './components/details-section/details-section.component';
import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { DisplayCategoriesComponent } from './components/display-categories/display-categories.component';
import { EditFormComponent } from './components/edit-form/edit-form.component';
import { EditSectionHeaderComponent } from './components/edit-section-header/edit-section-header.component';
import { EmployeeEstatesComponent } from './components/employee-estates/employee-estates.component';
import { ExpandableListComponent } from './components/expandable-list/expandable-list.component';
import { ExternNewsFormComponent } from './components/extern-news-form/extern-news-form.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { FilesListInSummaryComponent } from './components/files-list-in-summary/files-list-in-summary.component';
import { FilterOptionsComponent } from './components/filter-options/filter-options.component';
import { FilterSorterOptionsComponent } from './components/filter-sorter-options/filter-sorter-options.component';
import { FiltersArrayComponent } from './components/filters-array/filters-array.component';
import { FormButtonComponent } from './components/form-button/form-button.component';
import { FormRequirementComponent } from './components/form-requirement/form-requirement.component';
import { FormSectionCategoryComponent } from './components/form-section-category/form-section-category.component';
import { FormSectionComponent } from './components/form-section/form-section.component';
import { HistoryComponent } from './components/history/history.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { IconItemBarComponent } from './components/icon-item-bar/icon-item-bar.component';
import { ImageCarouselViewerComponent } from './components/image-carousel-viewer/image-carousel-viewer.component';
import { ImagePreviewCarouselComponent } from './components/image-preview-carousel/image-preview-carousel.component';
import { ImagePreviewItemComponent } from './components/image-preview-item/image-preview-item.component';
import { ImagePreviewListComponent } from './components/image-preview-list/image-preview-list.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { CheckboxInputComponent } from './components/inputs/checkbox-input/checkbox-input.component';
import { InputErrorsComponent } from './components/inputs/common/input-errors/input-errors.component';
import { InputFooterComponent } from './components/inputs/common/input-footer/input-footer.component';
import { InputHeaderComponent } from './components/inputs/common/input-header/input-header.component';
import { ContactPhoneTypeFormComponent } from './components/inputs/contact-phone-type-form/contact-phone-type-form.component';
import { DateInputComponent } from './components/inputs/date-input/date-input.component';
import { EmojiInputListComponent } from './components/inputs/emoji-input/emoji-input-list/emoji-input-list.component';
import { EmojiInputComponent } from './components/inputs/emoji-input/emoji-input.component';
import { PasswordInputComponent } from './components/inputs/password-input/password-input.component';
import { RadioInputComponent } from './components/inputs/radio-input/radio-input.component';
import { SearchFieldComponent } from './components/inputs/search-field/search-field.component';
import { SelectInputComponent } from './components/inputs/select-input/select-input.component';
import { SlideToggleInputComponent } from './components/inputs/slide-toggle-input/slide-toggle-input.component';
import { StarRatingComponent } from './components/inputs/star-rating/star-rating.component';
import { TextInputComponent } from './components/inputs/text-input/text-input.component';
import { TimeInputComponent } from './components/inputs/time-input/time-input.component';
import { LabeledDataLighterComponent } from './components/labeled-data-lighter/labeled-data-lighter.component';
import { LabeledDataComponent } from './components/labeled-data/labeled-data.component';
import { LandRegisterWithCopyComponent } from './components/land-register-with-copy/land-register-with-copy.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MeterTemplateComponent } from './components/meter-template/meter-template.component';
import { NewInfoComponent } from './components/new-info/new-info.component';
import { NewMessageButtonComponent } from './components/new-message-button/new-message-button.component';
import { NotesComponent } from './components/notes/notes.component';
import { NotificationTypeSelectComponent } from './components/notification-type-select/notification-type-select.component';
import { NotifySettingsComponent } from './components/notify-settings/notify-settings.component';
import { OnboardingPlaceholderComponent } from './components/onboarding-placeholder/onboarding-placeholder.component';
import { OrderButtonsComponent } from './components/order-buttons/order-buttons.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PersonEditFormComponent } from './components/person-edit-form/person-edit-form.component';
import { PersonFormDataPreviewComponent } from './components/person-form-data-preview/person-form-data-preview.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { PseudoLinkComponent } from './components/pseudo-link/pseudo-link.component';
import { QrCodePreviewComponent } from './components/qr-code-preview/qr-code-preview.component';
import { RangedReportDialogComponent } from './components/ranged-report-dialog/ranged-report-dialog.component';
import { ReceiversSelectContentComponent } from './components/receivers-select-preview/receivers-select-content/receivers-select-content.component';
import { ReceiversSelectDialogComponent } from './components/receivers-select-preview/receivers-select-dialog/receivers-select-dialog.component';
import { ReceiversSelectFiltersComponent } from './components/receivers-select-preview/receivers-select-filters/receivers-select-filters.component';
import { ReceiversSelectPreviewComponent } from './components/receivers-select-preview/receivers-select-preview.component';
import { ReportDataDateComponent } from './components/report-data-date/report-data-date.component';
import { RequiredIndicatorComponent } from './components/required-indicator/required-indicator.component';
import { ResidentUserSelectComponent } from './components/resident-user-select/resident-user-select.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { ScrollableDialogComponent } from './components/scrollable-dialog/scrollable-dialog.component';
import { ShowMoreOrLessTextComponent } from './components/show-more-or-less-text/show-more-or-less-text.component';
import { SummaryDialogComponent } from './components/summary-dialog/summary-dialog.component';
import { TabFilterComponent } from './components/tab-filter/tab-filter.component';
import { TabNavigationComponent } from './components/tab-navigation/tab-navigation.component';
import { TemplateFillFormComponent } from './components/template-fill-form/template-fill-form.component';
import { TileSectionComponent } from './components/tile-section/tile-section.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TranslateButtonComponent } from './components/translate-button/translate-button.component';
import { TwoColumnPageComponent } from './components/two-column-page/two-column-page.component';
import { UserCommunicationFormComponent } from './components/user-communication-form/user-communication-form.component';
import { UserResidentsComponent } from './components/user-residents/user-residents.component';
import { VoteProgressComponent } from './components/vote-progress/vote-progress.component';
import { NgMultiCaseDirective } from './directives/ngMultiCase.directive';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { TimeInputDirective } from './directives/time-input.directive';
import { GusAutofillButtonComponent } from './integrations/gus-api/gus-autofill-button/gus-autofill-button.component';
import { AddressPipe } from './pipes/address.pipe';
import { ArrayConcatConditionalPipe, ArrayConcatPipe, ObjectArrayFilterPipe } from './pipes/array.pipe';
import { AttHistoryPipe } from './pipes/att-history.pipe';
import { BooleanHRPipe } from './pipes/boolean-hr.pipe';
import { ClickableUrlPipe } from './pipes/clickable-url.pipe';
import { DateFromToPipe } from './pipes/date-from-to.pipe';
import { DefectTypePipe } from './pipes/defect-type.pipe';
import { FileSizePipe } from './pipes/fileSize.pipe';
import { GetStorageURLPipe } from './pipes/getStorageURL.pipe';
import { LocLabelFactoryPipe } from './pipes/loc-label-factory.pipe';
import {
  KeyIfElsePipe,
  LocalizationPipe,
  LocalizeCapitalizePipe,
  LocalizeDateTimePipe,
  LocalizeIfElsePipe,
  LocalizeLabelPipe,
  LocalizeLowerCasePipe,
  LocalizeNumberPipe,
  LocalizePluralPipe,
  LocalizeReplacePipe,
  LocalizeUpperCasePipe,
  LocLabelIfElsePipe,
  RelativeDaysPipe,
  RelativeTimePipe,
  TimeValuePipe
} from './pipes/localization.pipe';
import { MatIconPipe } from './pipes/matIcon.pipe';
import { SanitizeHTMLPipe } from './pipes/sanitize.pipe';
import {
  CapitalizePipe,
  FullNamePipe,
  IbanPipe,
  JoinPipe,
  ToStringOrPipe,
  AppNamePipe,
  NipPipe,
  RegonPipe,
  PhonePipe,
  GetPhonePipe,
  GetEmailPipe,
  ContactNamePipe,
  ShortNumberPipe,
  LongNumberPipe,
  ShortenPipe
} from './pipes/string.pipes';
import { VoteTermPipe } from './pipes/vote-term.pipe';
import { TemplateServiceComponent } from './services/template-service/template-service.component';

const sharedModules = [
  CommonModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatTabsModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatGridListModule,
  ReactiveFormsModule,
  FormsModule,
  RouterModule,
  MatProgressSpinnerModule,
  NgxMatSelectSearchModule,
  MatTooltipModule,
  MatRadioModule,
  MatChipsModule,
  AngularEditorModule,
  MatExpansionModule,
  TranslateModule,
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule
];

const components = [
  ClickableRowTableComponent,
  TabNavigationComponent,
  AvatarComponent,
  LoaderComponent,
  TextInputComponent,
  InputErrorsComponent,
  SelectInputComponent,
  DateInputComponent,
  CheckboxInputComponent,
  MeterTemplateComponent,
  RadioInputComponent,
  ProgressBarComponent,
  AppInvitationComponent,
  DisplayCategoriesComponent,
  FilterSorterOptionsComponent,
  CropImageComponent,
  ContactPhoneTypeFormComponent,
  ImagePreviewListComponent,
  ImagePreviewItemComponent,
  ImagePreviewCarouselComponent,
  ImageCarouselViewerComponent,
  AttachmentListInFormComponent,
  AttachmentListInViewComponent,
  ImagePreviewListComponent,
  ImageViewerComponent,
  LabeledDataComponent,
  LabeledDataLighterComponent,
  AddPictureFieldComponent,
  ExpandableListComponent,
  ConfirmationDialogComponent,
  DateConfirmationDialogComponent,
  EditFormComponent,
  DetailsHeaderComponent,
  ShowMoreOrLessTextComponent,
  AddAttachmentFieldComponent,
  IconButtonComponent,
  SearchFieldComponent,
  PageHeaderComponent,
  DialogHeaderComponent,
  DetailsSectionComponent,
  ContactBoxComponent,
  DetailsContactsComponent,
  FormSectionComponent,
  NotificationTypeSelectComponent,
  AddPictureIconComponent,
  EditSectionHeaderComponent,
  TooltipComponent,
  ScrollableDialogComponent,
  GusAutofillButtonComponent,
  NewMessageButtonComponent,
  CoOwnerIconComponent,
  VoteProgressComponent,
  TabFilterComponent,
  RichTextEditorComponent,
  UserCommunicationFormComponent,
  FormSectionCategoryComponent,
  SummaryDialogComponent,
  HistoryComponent,
  FormButtonComponent,
  FormRequirementComponent,
  PasswordInputComponent,
  InputHeaderComponent,
  InputFooterComponent,
  TileSectionComponent,
  FilesListInSummaryComponent,
  NotesComponent,
  FilterOptionsComponent,
  FiltersArrayComponent,
  PseudoLinkComponent,
  OrderButtonsComponent,
  TwoColumnPageComponent,
  NewInfoComponent,
  ReportDataDateComponent,
  ResidentUserSelectComponent,
  TemplateServiceComponent,
  ExternNewsFormComponent,
  EmployeeEstatesComponent,
  LandRegisterWithCopyComponent,
  IconItemBarComponent,
  ContactLinkComponent,
  FileInputComponent,
  PersonEditFormComponent,
  PersonFormDataPreviewComponent,
  ApxChartWrapperComponent,
  EmojiInputComponent,
  EmojiInputListComponent,
  ProgressSpinnerComponent,
  RangedReportDialogComponent,
  ReceiversSelectPreviewComponent,
  ReceiversSelectDialogComponent,
  ReceiversSelectFiltersComponent,
  UserResidentsComponent,
  MenuItemComponent,
  OnboardingPlaceholderComponent,
  SlideToggleInputComponent,
  TemplateFillFormComponent,
  RequiredIndicatorComponent,
  TimeInputComponent,
  NotifySettingsComponent,
  BrowserNtfToastComponent,
  ReceiversSelectContentComponent,
  StarRatingComponent,
  QrCodePreviewComponent,
  ActiveCallOverlayComponent,
  TranslateButtonComponent
];

const directives = [PhoneMaskDirective, NgMultiCaseDirective, TimeInputDirective];

const pipes = [
  ObjectArrayFilterPipe,
  ClickableUrlPipe,
  AddressPipe,
  CapitalizePipe,
  FullNamePipe,
  JoinPipe,
  IbanPipe,
  NipPipe,
  RegonPipe,
  ToStringOrPipe,
  DateFromToPipe,
  AppNamePipe,
  PhonePipe,
  BooleanHRPipe,
  ArrayConcatPipe,
  ArrayConcatConditionalPipe,
  LocalizeCapitalizePipe,
  LocalizeUpperCasePipe,
  LocalizeLowerCasePipe,
  LocalizationPipe,
  LocalizeReplacePipe,
  LocalizeDateTimePipe,
  LocalizePluralPipe,
  LocalizeNumberPipe,
  LocalizeLabelPipe,
  GetStorageURLPipe,
  GetPhonePipe,
  GetEmailPipe,
  VoteTermPipe,
  SanitizeHTMLPipe,
  ContactNamePipe,
  MatIconPipe,
  ShortNumberPipe,
  LongNumberPipe,
  ShortenPipe,
  DefectTypePipe,
  FileSizePipe,
  RelativeTimePipe,
  RelativeDaysPipe,
  TimeValuePipe,
  LocLabelFactoryPipe,
  AttHistoryPipe,
  LocalizeIfElsePipe,
  KeyIfElsePipe,
  LocLabelIfElsePipe
];

@NgModule({
  imports: [...sharedModules, ImageCropperModule, NgApexchartsModule, DragDropModule, NgMultiSelectDropDownModule.forRoot()],
  exports: [...sharedModules, ...components, ...directives, ...pipes],
  declarations: [...components, ...directives, ...pipes],
  providers: [
    DatePipe,
    { provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: NgxMatDateAdapter, useClass: CustomNgxDateAdapter },
    BooleanHRPipe,
    LocalizationPipe,
    AsyncPipe,
    SanitizeHTMLPipe,
    AngularEditorService,
    GetStorageURLPipe
  ]
})
export class SharedModule {}
